export const chartOptions = {
  chart: {
    id: "basic-bar",
    type: "bar",
    background: '#fafafa',
    foreColor: '#333',
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 400,
      animateGradually: {
        enabled: true,
        delay: 200
      },
      dynamicAnimation: {
        enabled: true,
        speed: 550
      }
    },
    title: {
      text: 'Tasks',
      align: 'center',
      floating: true,
      style: {
        fontSize: '20px'
      }
    },

  },

  xaxis: {
    categories: ['Completed Tasks', 'Processing Tasks', 'Failed Tasks'],
    labels: {
      style: {
        colors: '005f05'
      }
    },
  },

  yaxis: {
    labels: {
      style: {
        fontSize: '15px',
        fontWeight: 'bolder',
        // colors: ['#fff', '#c20707'],

      }
    },

    axisBorder: {
      show: true,
      color: '#ddd',
      offsetX: -8,
      offsetY: 0
    },

  },


  plotOptions: {
    bar: {
      horizontal: false,
      distributed: true,
      barHeight: '50px',
      style: {
        color: 'red'
      }
    },
    barHeight: '50%'
  },
  colors: ['#0e6d7e', '#df8a1c', '#c20707']

}


export const series = [
  {
    data: [0, 0, 0],
    name: 'Task count'
  }
]



export const tooltip = {
  theme: 'dark',
  x: {
    show: false
  },
  y: {
    title: {
      formatter: function () {
        return ''
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/chartOptions.js